<template>
  <article >
    <article class="content listed file">
      <i class="fal fa-file-image file-type icon"   v-on:click="openLink(content.attributes.url)"></i>
      <div class="file-name" v-if="!isSharedFromAnotherRally"  v-on:click="openLink(content.attributes.url)">
        {{ content.attributes.title }}
      </div>
      <div v-if="isSharedFromAnotherRally" v-on:click="openLink(content.attributes.url)" class="shared-title">
        {{
          content.attributes.title
        }} <span class="shared">(SHARED by {{sharedByName}})</span>
      </div>
      <div class="author-name">
        {{ byLine }}
      </div>
      <div v-if="!stillLoading" class="other-info">
        {{ Math.round(content.attributes["file-size"]/1000) + " KB"}} | 
        {{ formatDate(content.attributes["created-at"]) }}
      </div>
      <div v-if="stillLoading" class="other-info">
           <i class="fas fa-spinner fa-spin"></i>
      </div>
       
      <ContentPin :content="content"/>
      <ContentElipsisMenu  @moveFile="openMoveModal" :content="content" :rallyId="this.rallyId"
                          :channelId="this.channelId" contentType="Files" canDownload="true" canShare="true"
                          canMove="true" hideSentiments="true" :contextShare="contextShare"/>

    </article>
    <Comments :shareId="content.relationships['context-share'].data.id" :avatarFile="content.attributes['creator-avatar']" :channelId="channelId" :rallyId="this.rallyId"/>
  </article>
</template>

<script>
  import BinaryMixin from "../../BinaryMixin";
  import ContentMixin from "../../ContentMixin";
  import { Browser } from '@capacitor/browser';
  import { mapActions } from "vuex";

export default {
  name: "File",
  mixins: [
    BinaryMixin,
    ContentMixin,
  ],
    props: {
      channel: Object,
      rally: Object,
      content: Object,
      contextShare: Object,
  },
  computed: {
    stillLoading(){
      return Math.round(this.content.attributes['file-size']/1000) == 0
    },
  },
  mounted() {
    window.scrollTo(-500, -500);
  },
  methods: {
    ...mapActions('user', ['setModalProps']),
    openLink(url) {
      Browser.open({ url: url });
    },
    openMoveModal() {
      this.setModalProps({
        name: 'MoveFileModal',
        channelId: this.channelId,
        contextShare: this.contextShare,
        rallyId: this.rallyId,
      })
    },
  },
};
</script>
